import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {ErrorHandlerService} from "../error-handler/error-handler.service";
import { ModulTozsamosciService } from 'src/app/auth-lib/src/public-api';
import { NewsletterService } from '../newsletter.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private errorHandlerService: ErrorHandlerService,
    private mtService: ModulTozsamosciService,
    private newsletterService: NewsletterService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
    .pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status === 401 || error.status === 403) {
          this.mtService.logOut(true);
          this.mtService.initLoginFlow();
        } else {
          this.errorHandlerService.setErrorAndRequest(error, request);
        }
        return throwError(error);
      })
    );
  }
}
